import { useEffect, useState } from 'react'
import { getSelectedCurrency } from '@helpers/currency'
import { getNativeCurrencyCode } from '@helpers/env'

// Flips to true once the app has hydrated. Kept at module scope so that
// component instances mounted after hydration (e.g. remounts from switching
// collection pills) can read the real currency on their first render instead
// of defaulting to native and flashing GBP for a frame.
let hasHydrated = false

export default function useBrowsingInNativeCurrency(): boolean {
  const [isMounted, setIsMounted] = useState(hasHydrated)

  useEffect(() => {
    hasHydrated = true
    setIsMounted(true)
  }, [])

  return isMounted ? browsingInNativeCurrency() : true
}

export function browsingInNativeCurrency(): boolean {
  const selectedCurrency = getSelectedCurrency()
  return !selectedCurrency || selectedCurrency === getNativeCurrencyCode()
}
